module.exports = __webpack_public_path__ + "static/SignaturaMonolineScript-Regular-91504f7d612b823caa7389e105a2a728.woff2";